module.exports = __webpack_public_path__ + "twitter.svg?dfce3d605509763ee5d26906e4229e9e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/twitter.svg
// module id = 21
// module chunks = 0